/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'typeword': {
    width: 200,
    height: 233.186,
    viewBox: '0 0 200 233.186',
    data: '<g fill-rule="evenodd"><path pid="0" d="M200 196.39V61.84c0-8.29-3.29-16.24-9.15-22.1L160.26 9.15A31.252 31.252 0 00138.16 0H36.8C16.47 0 0 16.48 0 36.8v159.59c0 20.32 16.48 36.8 36.8 36.8h126.4c20.33 0 36.8-16.48 36.8-36.8z" _fill="#4a8dff"/><path pid="1" d="M160.258 9.156a31.222 31.222 0 00-16.08-8.57v34.34c0 10.9 8.84 19.74 19.74 19.74h35.24a31.224 31.224 0 00-8.31-14.92l-30.59-30.59z" _fill="#e5f0ff"/></g><path pid="2" fill-rule="evenodd" d="M94.668 118.37l-38.84 42.54V82.26h-19.54V186.1c0 8.92 10.97 13.17 16.98 6.59l48.62-53.25 48.61 53.25c6.01 6.58 16.98 2.33 16.98-6.59V82.26h-19.54v78.65l-38.84-42.54c-3.87-4.25-10.55-4.25-14.43 0z" _fill="#fff"/>'
  }
})
